import { Modal } from 'antd'
import { I18nContext } from 'contexts/I18n/I18nProvider'
import { useContext } from 'react'
import './index.scss'

type ConfirmationModalProps = {
  isOpen: boolean
  isCentered?: boolean
  title?: string
  onConfirm: () => void
  onCancel: () => void
  children: React.ReactNode
}

export default function ({isOpen, title='Confirmation Modal', isCentered=true, onConfirm, onCancel, children}: ConfirmationModalProps) {
  const t = useContext(I18nContext)
  return (
    <div>
      <Modal
        classNames={{ content: 'upload-modal' }}
        open={isOpen} 
        title={t(title)} 
        centered={isCentered}
        closable 
        onCancel={onCancel}
        destroyOnHidden
        footer={[
          <button key="ok" className="button is-larger is-primary" onClick={onConfirm}>
            {t('general.confirm')}
          </button>,
          <button key="cancel" className="button is-larger" onClick={onCancel}>
            {t('general.cancel')}
          </button>
        ]}
        >
          {children}
      </Modal> 
    </div>
  )
}
